var _CUSTOM_COD_FORM_PROVINCES = {
    data: {"Jalisco":{"Guadalajara":{"44100":true,"44110":true,"44130":true,"44140":true,"44150":true,"44158":true,"44160":true,"44170":true,"44180":true,"44190":true,"44200":true,"44210":true,"44214":true,"44215":true,"44216":true,"44217":true,"44218":true,"44219":true,"44220":true,"44227":true,"44230":true,"44240":true,"44246":true,"44247":true,"44249":true,"44250":true,"44257":true,"44259":true,"44260":true,"44265":true,"44266":true,"44267":true,"44270":true,"44280":true,"44290":true,"44298":true,"44299":true,"44300":true,"44306":true,"44307":true,"44320":true,"44329":true,"44330":true,"44340":true,"44349":true,"44350":true,"44360":true,"44370":true,"44380":true,"44390":true,"44395":true,"44398":true,"44399":true,"44400":true,"44410":true,"44419":true,"44420":true,"44430":true,"44440":true,"44450":true,"44460":true,"44467":true,"44469":true,"44470":true,"44490":true,"44493":true,"44500":true,"44510":true,"44520":true,"44530":true,"44535":true,"44538":true,"44540":true,"44549":true,"44550":true,"44559":true,"44560":true,"44580":true,"44600":true,"44610":true,"44619":true,"44620":true,"44630":true,"44635":true,"44647":true,"44648":true,"44650":true,"44656":true,"44657":true,"44658":true,"44660":true,"44665":true,"44667":true,"44668":true,"44670":true,"44678":true,"44679":true,"44680":true,"44689":true,"44690":true,"44700":true,"44710":true,"44716":true,"44719":true,"44720":true,"44723":true,"44724":true,"44725":true,"44726":true,"44727":true,"44729":true,"44730":true,"44737":true,"44739":true,"44740":true,"44748":true,"44750":true,"44755":true,"44757":true,"44760":true,"44765":true,"44766":true,"44768":true,"44769":true,"44770":true,"44780":true,"44790":true,"44799":true,"44800":true,"44810":true,"44815":true,"44817":true,"44818":true,"44820":true,"44824":true,"44825":true,"44827":true,"44828":true,"44829":true,"44840":true,"44860":true,"44870":true,"44890":true,"44895":true,"44897":true,"44898":true,"44899":true,"44900":true,"44910":true,"44918":true,"44919":true,"44920":true,"44929":true,"44930":true,"44940":true,"44948":true,"44950":true,"44956":true,"44959":true,"44960":true,"44966":true,"44967":true,"44969":true,"44970":true,"44977":true,"44978":true,"44980":true,"44984":true,"44985":true,"44986":true,"44987":true,"44989":true,"44990":true},"Zapopan":{"45010":true,"45012":true,"45014":true,"45015":true,"45016":true,"45017":true,"45018":true,"45019":true,"45020":true,"45027":true,"45030":true,"45034":true,"45036":true,"45037":true,"45038":true,"45039":true,"45040":true,"45047":true,"45049":true,"45050":true,"45053":true,"45054":true,"45055":true,"45056":true,"45057":true,"45058":true,"45059":true,"45060":true,"45065":true,"45066":true,"45067":true,"45068":true,"45069":true,"45070":true,"45076":true,"45077":true,"45078":true,"45079":true,"45080":true,"45085":true,"45086":true,"45087":true,"45088":true,"45089":true,"45100":true,"45110":true,"45115":true,"45116":true,"45117":true,"45118":true,"45119":true,"45120":true,"45128":true,"45129":true,"45130":true,"45133":true,"45134":true,"45136":true,"45138":true,"45140":true,"45145":true,"45146":true,"45147":true,"45148":true,"45149":true,"45150":true,"45157":true,"45158":true,"45159":true,"45160":true,"45167":true,"45168":true,"45169":true,"45170":true,"45176":true,"45177":true,"45178":true,"45179":true,"45180":true,"45184":true,"45185":true,"45186":true,"45187":true,"45188":true,"45189":true,"45190":true,"45198":true,"45199":true,"45200":true,"45205":true,"45210":true,"45213":true,"45220":true,"45221":true,"45222":true,"45226":true,"45230":true,"45233":true,"45234":true,"45235":true,"45236":true,"45237":true,"45238":true,"45239":true,"45242":true,"45245":true},"El Arenal":{"45350":true,"45353":true,"45355":true,"45359":true,"45360":true,"45364":true,"45368":true},"Tonalá":{"45400":true,"45402":true,"45403":true,"45404":true,"45405":true,"45406":true,"45407":true,"45408":true,"45410":true,"45412":true,"45413":true,"45415":true,"45416":true,"45417":true,"45420":true,"45422":true,"45424":true,"45425":true,"45426":true,"45427":true,"45428":true,"45429":true},"San Pedro Tlaquepaque":{"45500":true,"45509":true,"45510":true,"45519":true,"45520":true,"45525":true,"45527":true,"45528":true,"45530":true,"45535":true,"45540":true,"45550":true,"45559":true,"45560":true,"45567":true,"45570":true,"45579":true,"45580":true,"45588":true,"45589":true,"45590":true,"45593":true,"45594":true,"45595":true,"45596":true,"45597":true,"45598":true,"45599":true,"45600":true,"45601":true,"45602":true,"45604":true,"45605":true,"45606":true,"45607":true,"45608":true,"45609":true,"45610":true,"45613":true,"45615":true,"45618":true,"45619":true,"45620":true,"45623":true,"45625":true,"45626":true,"45627":true,"45628":true,"45629":true,"45630":true,"45638":true},"Tlajomulco de Zúñiga":{"45640":true,"45641":true,"45643":true,"45644":true,"45645":true,"45646":true,"45647":true,"45650":true,"45653":true,"45654":true,"45655":true,"45656":true,"45659":true,"45660":true,"45663":true,"45664":true,"45665":true,"45670":true,"45672":true,"45675":true,"45676":true,"45677":true,"45678":true,"45679":true},"El Salto":{"45680":true,"45683":true,"45685":true,"45686":true,"45687":true,"45690":true,"45692":true,"45693":true,"45694":true,"45696":true}}},
    startFields: function () {
      try {
        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
        _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
  
        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
        document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
      } catch (e) {
        console.log(e);
      }
    },
    onProvinceChange: function () {
      var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
  
      var html = "";
  
      if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
        html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
        document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
        document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
        _CUSTOM_COD_FORM_PROVINCES.onCityChange();
        return;
      }
  
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
  
      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
        html += '<option value="' + item + '">' + item + '</option>';
      });
  
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
  
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
    },
    onCityChange: function () {
      var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
      var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;
  
      var html = "";
  
      if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
        html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
        document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
        document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
        return;
      }
  
      if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
        html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
        document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
        document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
        return;
      }
  
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
  
      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
        html += '<option value="' + item + '">' + item + '</option>';
      });
  
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
    }
  };
  
  
  function _COD_FORM_ON_OPEN_INIT_END_DEF() {
    try {
      if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
        _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
      }
    } catch (e) {
      console.log(e);
    }
    _CUSTOM_COD_FORM_PROVINCES.startFields();
  }
  
  function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
    try {
      if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
        _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
      }
  
      var onTimeout = function () {
        if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
          _CUSTOM_COD_FORM_PROVINCES.startFields();
        } else {
          setTimeout(onTimeout, 500);
        }
      }
  
      setTimeout(onTimeout, 500);
    } catch (e) {
      console.log(e);
    }
  }
  
  function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
    try {
      if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
        _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
      }
  
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
    } catch (e) {
      console.log(e);
    }
  }
  
  var _COD_FORM_CITY_LABEL = "";
  var _COD_FORM_ZIP_LABEL = "";
  
  function _COD_FORM_OVERWRITE_INIT() {
    _rsi.s.form.fields.items_array.forEach(function (item) {
      if (item.type == "province_country_field" || item.type == "province") {
        item.type = "province_country_field";
        item.backendFields.name = "province_country_field";
        item.backendFields.elementType = "select";
  
        var options = [];
  
        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
          options.push({
            label: key,
            value: key
          })
        })
  
  
        item.backendFields.options = options;
      } else if (item.type == "city") {
        item.type = "city_country_field";
        item.backendFields.name = "city";
        item.backendFields.elementType = "select";
        if (item.n) {
          if (item.n.ph) {
            _COD_FORM_CITY_LABEL = item.n.ph;
          }
        }
        if (!_COD_FORM_CITY_LABEL) {
          _COD_FORM_CITY_LABEL = item.label;
        }
        var options = [{
          value: "", label: _COD_FORM_CITY_LABEL
        }];
        item.backendFields.options = options;
      } else if (item.type == "zip_code") {
        item.type = "zip_country_field";
        item.backendFields.name = "zip_code";
        item.backendFields.elementType = "select";
        if (item.n) {
          if (item.n.ph) {
            _COD_FORM_ZIP_LABEL = item.n.ph;
          }
        }
        if (!_COD_FORM_ZIP_LABEL) {
          _COD_FORM_ZIP_LABEL = item.label;
        }
        var options = [{
          value: "", label: _COD_FORM_ZIP_LABEL
        }];
        item.backendFields.options = options;
      }
    });
  
    try {
      if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
        if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
          return false;
        }
      }
    } catch (e) {
      console.log(e);
    }
  
    return true;
  }





 